
export class DemoUserSerializer {

    private static INSTANCE = new  DemoUserSerializer();

    static get instance() {
        return this.INSTANCE;
    }


    public serializeAppList(payload: any) {
        const apps = payload.apps ? payload.apps : [];
        return apps;
    }

}

export const demoUserSerializer = DemoUserSerializer.instance;
